import React, { useEffect, useState } from 'react';
import Header from '../components/headerComp';
import Menu from '../components/menuComp';
import Footer from '../components/footerComp';
import ProductCard from '../components/productCard';
import { Container, Row } from 'react-bootstrap';

const IWB = () => {
  const [iwbItems, setIwbItems] = useState([]);

  useEffect(() => {
    fetch('/items.json?v=2')
      .then(response => response.json())
      .then(data => {
        const iwbItems = data.filter(item => item.category === 'Iwb');
        setIwbItems(iwbItems);
      })
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  return (
    <div>
      <Header />
      <Menu />
      <Container className='pb-5 pb-sm-10'>
        <Row>
          {iwbItems.map(item => (
            <ProductCard key={item.stockNumber} item={item} />
          ))}
        </Row>
      </Container>
      <Footer />
    </div>
  );
}

export default IWB;
